module.exports = {
	"id": "LS",
	"name": "Lesotho",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.00897,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": 0.05681,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.02691,
			"27": 0.00598,
			"28": 0.004485,
			"29": null,
			"30": null,
			"31": 0.04485,
			"32": null,
			"33": 0.01196,
			"34": 0.007475,
			"35": null,
			"36": 0.01495,
			"37": null,
			"38": 0.00897,
			"39": 0.019435,
			"40": 0.06279,
			"41": 0.00299,
			"42": 0.004485,
			"43": 0.08372,
			"44": 0.00299,
			"45": 0.034385,
			"46": 0.070265,
			"47": 0.016445,
			"48": 0.010465,
			"49": 0.15847,
			"50": 0.115115,
			"51": 0.14651,
			"52": 0.130065,
			"53": 2.803125,
			"54": 0.710125,
			"55": 0.00897,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.100165,
			"4": 0.00598,
			"5": 0.004485,
			"6": 0.00598,
			"7": null,
			"8": null,
			"9": null,
			"10": 0.00299,
			"11": 0.00598,
			"12": null,
			"13": 0.004485,
			"14": null,
			"15": 0.00299,
			"16": 0.001495,
			"17": 0.00299,
			"18": null,
			"19": 0.034385,
			"20": 0.01196,
			"21": 0.00598,
			"22": 0.007475,
			"23": 0.016445,
			"24": null,
			"25": 0.007475,
			"26": null,
			"27": 0.001495,
			"28": 0.001495,
			"29": 0.03887,
			"30": 0.010465,
			"31": 0.00598,
			"32": 0.00299,
			"33": 0.004485,
			"34": 0.00897,
			"35": 0.004485,
			"36": 0.010465,
			"37": 0.025415,
			"38": 0.00598,
			"39": 0.150995,
			"40": 0.00897,
			"41": 0.013455,
			"42": 0.04784,
			"43": 0.070265,
			"44": 0.070265,
			"45": 0.03588,
			"46": 0.02691,
			"47": 0.30199,
			"48": 0.222755,
			"49": 0.934375,
			"50": 0.127075,
			"51": null,
			"52": null,
			"3.5": 0.004485,
			"3.6": 0.02093
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.00299,
			"15": 0.001495,
			"16": null,
			"17": 0.010465,
			"18": null,
			"19": 0.00598,
			"20": null,
			"21": 0.001495,
			"22": null,
			"23": null,
			"24": 0.004485,
			"25": null,
			"26": null,
			"27": 0.007475,
			"28": 0.00598,
			"29": 0.019435,
			"30": 0.04784,
			"31": null,
			"32": 0.010465,
			"33": 0.00897,
			"34": 0.01495,
			"35": 0.052325,
			"36": 0.02392,
			"37": 0.13455,
			"38": 0.00598,
			"39": 0.034385,
			"40": 0.273585,
			"41": 0.025415,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": 0.00299,
			"11.6": null,
			"12.1": 0.004485
		},
		"safari": {
			"0": null,
			"4": 0,
			"5": 0.007475,
			"6": null,
			"7": null,
			"8": 0.004485,
			"9": 0.004485,
			"10": 0.02691,
			"3.1": null,
			"3.2": null,
			"5.1": 0.007475,
			"6.1": 0.00598,
			"7.1": 0.016445,
			"9.1": 0.03588
		},
		"ios_saf": {
			"8": 0,
			"10": 0.319769587843,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.00861742037885,
			"8.1-8.4": 0.015920319005,
			"9.0-9.2": 0.00759501457119,
			"9.3": 0.115872658201
		},
		"android": {
			"3": 0,
			"4": 0.0479972093023,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00599965116279,
			"4.1": 0.173132790698,
			"4.2-4.3": 0.432831976744,
			"4.4": 0.99251372093,
			"4.4.3-4.4.4": 1.00108465116
		},
		"ie": {
			"6": 0.022425,
			"7": 0.004485,
			"8": 0.32292,
			"9": 0.11063,
			"10": 0.15548,
			"11": 1.269255,
			"5.5": null
		},
		"op_mob": {
			"0": 4.08633568317,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.113509324533
		},
		"edge": {
			"12": 0.136045,
			"13": 0.252655,
			"14": 0.13156
		},
		"ie_mob": {
			"10": 0.399136056338,
			"11": 1.62505394366
		},
		"bb": {
			"7": 0.32531625,
			"10": null
		},
		"samsung": {
			"0": 1.641465
		},
		"and_uc": {
			"0": 6.506325
		},
		"op_mini": {
			"0": 55.0544899923
		},
		"and_chr": {
			"0": 13.946415
		},
		"and_ff": {
			"0": 0.01701
		}
	},
	"total": 97.00089625
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/LS.json
 ** module id = 577
 ** module chunks = 0
 **/